import {ReactNode} from "react";
import RelativeTimeText from "../../../components/RelativeTimeText";
import {ApiDateTime} from "platformed-client/types";
import {compareOptional} from "../../../utils/compare";
import {compareApiDateTimes} from "../../../utils/date";
import {createColumn} from "../config";

export function createPresetDateTimeColumn<Item, Ctx>({
  label,
  extract,
  backendField,
  placeholder = "-",
}: {
  label: ReactNode;
  extract: (item: Item, ctx: Ctx) => ApiDateTime | null | undefined;
  /**
   * What is shown when the date is nullish?
   *
   * Default: "-"
   */
  placeholder?: ReactNode;
  backendField?: string;
}) {
  return createColumn({
    label,
    extract,
    compare: (a, b) => compareOptional(a, b, compareApiDateTimes),
    render: dateTime => {
      if (dateTime == null) {
        return placeholder;
      }

      return <RelativeTimeText dateTime={dateTime} />;
    },
    sort: {defaultDirection: "descending"},
    backendFields: backendField ? [backendField] : undefined,
  });
}
